@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Arkansas</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[0].formControlName)?.touched) {
              @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        }
      </div>

      <div class="axis-grid">
        @if (baseRules["Maximum_Medical_Expense_Benefits_Checkbox"]?.includes("show")) {
          <div class="_ml-large _mb-medium">
            <axis-checkbox
              [formControlName]="controls[1].formControlName"
              [heading]="controls[1].label"
            ></axis-checkbox>
          </div>
        }
        @if (baseRules["Work_Loss_Personal_Injury_Checkbox"]?.includes("show")) {
          <div class="_ml-large _mb-medium">
            <axis-checkbox
              [formControlName]="controls[2].formControlName"
              [heading]="controls[2].label"
            ></axis-checkbox>
          </div>
        }
        @if (baseRules["Accidental_Death_Benefits_Checkbox"]?.includes("show")) {
          <div class="_ml-large _mb-medium">
            <axis-checkbox
              [formControlName]="controls[3].formControlName"
              [heading]="controls[3].label"
            ></axis-checkbox>
          </div>
        }
      </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Arkansas</h2>
  @if (baseRules?.noSelection === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label">PIP Coverage will be provided at the limits available under state law.</label>
    </div>
  }
  @if (baseRules?.RejectedPersonalInjuryProtection_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.RejectedPersonalInjuryProtection_LevelOne_Radio_text }}
      </label>
    </div>
  }
}
